import { Canvas } from "@react-three/fiber";
import { Drill } from "./Drill";
import { Center, OrbitControls } from "@react-three/drei";
import { DirectionalLight } from "three";

export default function MyScene() {
  return (
    <Canvas
      scene={{ background: "0x000000" }}
      camera={{
        fov: 75,
        near: 0.1,
        far: 1000,
        aspect: window.innerWidth / window.innerHeight,
        position: [0, 0, 5],
      }}
    >
      <Center>
        <Drill />
      </Center>
      <OrbitControls />
      <ambientLight color={"0xffffff"} intensity={0.2} />
      <directionalLight color={"0xffffff"} intensity={2} />
    </Canvas>
  );
}
